import { c as _c } from "react/compiler-runtime";
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { PRODUCT_PROTECTION_PLANS_META } from 'data-hooks/queries';
import usePDPApolloQueryVariables from '../usePDPApolloQueryVariables';
const useProductProtectionPlans = (id, slug, t0) => {
  const $ = _c(12);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const queryOptions = t1;
  const {
    variables,
    skip
  } = usePDPApolloQueryVariables(id, slug);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      noBatch: true
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = queryOptions?.ssr ?? false;
  let t4;
  if ($[3] !== skip || $[4] !== t3 || $[5] !== variables) {
    t4 = {
      variables,
      skip,
      context: t2,
      ssr: t3,
      fetchPolicy: "cache-and-network"
    };
    $[3] = skip;
    $[4] = t3;
    $[5] = variables;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    loading,
    error,
    data,
    refetch
  } = useSuspenseQuery(PRODUCT_PROTECTION_PLANS_META, t4);
  const t5 = loading || !data;
  const t6 = data?.productProtectionPlans;
  let t7;
  if ($[7] !== error || $[8] !== refetch || $[9] !== t5 || $[10] !== t6) {
    t7 = {
      loading: t5,
      error,
      data: t6,
      refetch
    };
    $[7] = error;
    $[8] = refetch;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default useProductProtectionPlans;